import './abasictest/style';
import FormStructure from './abasictest/form_structure';

export default FormStructure;